<script setup lang="ts">
defineProps<{
  name?: string
}>()
</script>

<template>
  <GAList
    id="instant-search-products"
    :name="`Instant Search: ${name}`"
    entity="instantSearchProducts"
  >
    <slot />
  </GAList>
</template>
